export default {
    payload: 'Visit',
    inputClosing: 'Input Closing',
    inputCancel: 'Input Cancel',
    inputSale: 'Input Sale',
    inputTraffic: 'Input Traffic'
}